/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Qr_StartingInputs */



/**
* | output |
* | --- |
* | "Starting camera..." |
*
* @param {Deck_Upload_Qr_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_qr_starting = /** @type {((inputs?: Deck_Upload_Qr_StartingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Qr_StartingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de la caméra...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando cámara...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Iniciando câmera...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio fotocamera...")
	return /** @type {LocalizedString} */ ("Starting camera...")
});